import { render } from "./PuzzleCaptcha.vue?vue&type=template&id=79c29549&scoped=true"
import script from "./PuzzleCaptcha.vue?vue&type=script&lang=js"
export * from "./PuzzleCaptcha.vue?vue&type=script&lang=js"

import "./PuzzleCaptcha.vue?vue&type=style&index=0&id=79c29549&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c29549"]])

export default __exports__